<div class="page-title-area">
    <div class="container">
        <div class="page-title-content" *ngIf="pageDetail">
            <h2>{{pageDetail.title}}</h2>
            <ul>
                <li><a routerLink="/">Anasayfa </a></li>
                <li class="active">{{pageDetail.title}}</li>
            </ul>
        </div>
    </div>

    <div class="page-shape">
        <div class="shape1"><img src="assets/images/shape/1.png" alt="shape" /></div>
        <div class="shape3"><img src="assets/images/shape/3.png" alt="shape" /></div>
        <div class="shape4"><img src="assets/images/shape/4.png" alt="shape" /></div>
        <div class="shape5"><img src="assets/images/shape/5.png" alt="shape" /></div>
        <div class="shape6"><img src="assets/images/shape/6.png" alt="shape" /></div>
    </div>
</div>

<section class="team-area pt-100 pb-70">
    <div class="container">
        <div class="row"> <!-- Team Module -->
            <div class="col-lg-4 col-md-6">
                <div class="single-team">
                    <div class="team-img">
                        <img src="assets/images/team/g1.jpg" alt="team">
                    </div>

                    <div class="team-content">
                        <h3>Evana Doe</h3>
                        <p>Founder</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="single-team">
                    <div class="team-img">
                        <img src="assets/images/team/g3.jpg" alt="team">
                    </div>

                    <div class="team-content">
                        <h3>Maria Doe</h3>
                        <p>Manager</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="single-team">
                    <div class="team-img">
                        <img src="assets/images/team/g2.jpg" alt="team">
                    </div>
                    
                    <div class="team-content">
                        <h3>Smith Doe</h3>
                        <p>CEO</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="single-team">
                    <div class="team-img">
                        <img src="assets/images/team/g5.jpg" alt="team">
                    </div>

                    <div class="team-content">
                        <h3>Leo Doe</h3>
                        <p>Project Manager</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="single-team">
                    <div class="team-img">
                        <img src="assets/images/team/g4.jpg" alt="team">
                    </div>

                    <div class="team-content">
                        <h3>Jhon Doe</h3>
                        <p>Marketing Support</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="single-team">
                    <div class="team-img">
                        <img src="assets/images/team/g6.jpg" alt="team">
                    </div>

                    <div class="team-content">
                        <h3>Brian Cox</h3>
                        <p>Agent Management</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>